import React from 'react';
import Terms from '../component/Terms';

function MyTerms() {
  return <Terms />;
}

export default MyTerms;
